
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertifyService } from "../../../services/core/alertify.service";
import { StaticDataService } from "../../../services/core/static-data.service";
import { NoteType } from "../../../models/entity/noteType";
import { Note } from "../../../models/entity/note";
import { environment } from '../../../../environments/environment';
import { DefinitionCacheService } from '../../../services/cache/definition-cache.service';
import { firstValueFrom } from "rxjs";
import { StringUtils } from "../../../utils/string.utils";
import { ImageUrlConstant } from "../../../constant/image-url.constant";

@Component({
  selector: "app-note-select",
  templateUrl: "./note-select.component.html",
  styleUrls: ["./note-select.component.css"]
})
export class NoteSelectComponent implements OnInit {

  @Input() noteCategoryId: number;
  @Input() notes: string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  dataList: Note[] = [];
  dataListAll: Note[] = [];
  noteTypes: NoteType[];
  selectedNoteTypeId: number = 0;
  loading: boolean;
  showTab: boolean = true;
  imageBaseUrl;
  constructor(
    private staticDataService: StaticDataService,
    private definitionCacheService: DefinitionCacheService,
    private alertifyService: AlertifyService
  ) { }

  async ngOnInit() {
    this.imageBaseUrl = ImageUrlConstant.PRODUCT_NOTE_BASE_URL;
    this.getNoteTypes();
    await this.getDataAll();
  }

  getNoteTypes() {
    this.noteTypes = this.staticDataService.noteTypes.filter(x => x.noteCategoryId == this.noteCategoryId);

    this.selectedNoteTypeId = this.noteTypes[0].id!;
    if (this.noteTypes.length == 1)
      this.showTab = false;

  }

  // listeler
  async getDataAll() {
    try {
      this.loading = true;
      const res = await firstValueFrom(this.definitionCacheService.getNotesByCategory(this.noteCategoryId));
      this.dataListAll = res;
      this.getData();
    }
    catch (err) {
      this.alertifyService.error(err);
    }
    finally {

      this.loading = false;
    }


  }

  // listeler
  getData() {


    if (this.selectedNoteTypeId == 0) {
      this.dataList = [];
      return;
    }

    this.loading = true;

    this.dataList = this.dataListAll.filter(
      x => x.noteTypeId == this.selectedNoteTypeId
    );
    this.loading = false;
  }

  //tab değiştikçe
  onSelectTab(item: NoteType) {
    this.selectedNoteTypeId = item.id!;
    this.getData();

  }

  addSelectedNote(selected) {
    if (StringUtils.isEmpty(this.notes)) this.notes = selected;
    else this.notes += ", " + selected;
  }

  //kayıt seçildiğinde
  save() {
    this.passEntry.emit(this.notes);
  }

  close() {
    this.passEntry.emit();
  }
}
